import { WebView } from '@zenbusiness/application-commons-webview';
import Box from '@zenbusiness/zui/Box';
import Link from '@zenbusiness/zui/Link';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import { PHONE_NUMBER } from '#client/constants/phone';

import { PrintButton } from './AdditionalInfo.style';

export default function AdditionalInfo({ handlePrint = () => {} }) {
  const { isWebView } = WebView;
  return (
    <Stack
      alignItems={{ xs: 'left', md: 'center' }}
      flexDirection={{ xs: 'column', md: 'row' }}
      gap="16px"
      justifyContent="space-between"
      mt={{ xs: '32px', md: '40px' }}
    >
      {!isWebView && (
        <Box>
          <PrintButton
            color="info"
            onClick={handlePrint}
            size="small"
            variant="text"
          >
            Print this page
          </PrintButton>
        </Box>
      )}
      <Text
        color="primary"
        size="sm"
        weight="medium"
      >
        Notice a problem? Call{' '}
        <Link
          href={`tel:${PHONE_NUMBER}`}
          size="sm"
          underline="none"
          weight="medium"
        >
          {PHONE_NUMBER}
        </Link>
      </Text>
    </Stack>
  );
}

AdditionalInfo.propTypes = {
  handlePrint: PropTypes.func
};
